// src/components/FolderTree.jsx
import React, { useState } from 'react';
import { ChevronRight, ChevronDown, Folder, Package } from 'lucide-react';

const FolderTree = ({ data, onFolderClick }) => {
  // State to track expanded folders
  const [expandedFolders, setExpandedFolders] = useState(new Set());

  // Helper to sort folders by 'order' property
  const sortFolders = (folders = []) => {
    return [...folders].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  };

  // Toggle folder expansion
  const toggleFolder = (folderId, event) => {
    event.stopPropagation(); // Prevent triggering parent folder's click
    setExpandedFolders(prev => {
      const newSet = new Set(prev);
      if (newSet.has(folderId)) {
        newSet.delete(folderId);
      } else {
        newSet.add(folderId);
      }
      return newSet;
    });
  };

  const renderNode = (node) => {
    if (node.type === 'folder') {
      const isExpanded = expandedFolders.has(node.id);
      const hasChildren = node.children?.length > 0;

      return (
        <div key={node.id} className="pl-4">
          <div
            className="flex items-center py-1 hover:bg-muted/50 cursor-pointer"
            onClick={() => onFolderClick(node.id)}
          >
            {hasChildren && (
              <div 
                onClick={(e) => toggleFolder(node.id, e)}
                className="cursor-pointer"
              >
                {isExpanded ? (
                  <ChevronDown className="h-4 w-4 mr-1" />
                ) : (
                  <ChevronRight className="h-4 w-4 mr-1" />
                )}
              </div>
            )}
            <span>{node.name}</span>
          </div>
          {hasChildren && isExpanded && (
            <div className="pl-4">
              {sortFolders(node.children).map(child => renderNode(child))}
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  // Safely handle null/undefined data
  if (!data?.tree) {
    console.log('No tree data available');
    return <div className="p-2">No folders available</div>;
  }

  return (
    <div className="p-2">
      {sortFolders(data.tree).map(node => renderNode(node))}
    </div>
  );
};

export default FolderTree;